export default __webpack_public_path__ + "static/media/login-blue-quote.url.016f27f4e23780fb75a099c847ad87d1.svg";